import { complement, ifElse, isEmpty, isNil } from 'rambda';

export const isFilled = ifElse(isNil, () => false, complement(isEmpty));
